export default function camelCase(word) {
    const words = word.split('_');
    return words.reduce((a, b) => {
        const firstLetter = b.charAt(0).toUpperCase();
        return [a, firstLetter, b.substring(1)].join('');
    });
}
